import type {AxiosInstance} from 'axios';
import {ENDPOINTS} from 'general/constants';
import {logWithSentry} from 'sentry/sentry';

export const getPrice = async (instance: AxiosInstance): Promise<string> => {
    try {
        const res = await instance.get(`${ENDPOINTS.GET_PRICE(50643)}`);
        return res?.data?.price as string;
    } catch (error) {
        logWithSentry(error as Error);
        return '';
    }
};
